import React, { useEffect, useState } from 'react';

import SelectControl from '../../controls/SelectControl/SelectControl';
import PositionSizeControl from '../../controls/PositionSizeControl/PositionSizeControl';
import PositioningControl from '../../controls/PositioningControl/PositioningControl';
import DataProperties from '../ImageData/ImageData';
import { refreshTransform } from '../PropertiesHelper';
import RotationControl from '../../controls/RotationControl/RotationControl';
import BackgroundBorder from '../../controls/BackgroundBorderControl/BackgroundBorderControl';
import OpacityControl from '../../controls/OpacityControl/OpacityControl';
import CroppingControl from '../../controls/CroppingControl/CroppingControl';
import {
  transformerAnchors,
  transformerAnchorsFull,
} from '../../../../../constants';

import usePropertiesStore from '../../../stores/usePropertiesStore';
import useStageStore from '../../../stores/useStageStore';

import globalStyles from '../../GlobalGraphicEditor.module.css';

export default function (props) {
  const group = usePropertiesStore((s) => s.selectedGroup);
  const refreshToggle = usePropertiesStore((s) => s.propertiesRefreshTrigger);
  const onPropertyChanged = usePropertiesStore((s) => s.propertyChanged);
  const stage = useStageStore((s) => s.stage);

  const image = group?.findOne('Image');
  const background = group?.findOne('.background');

  const [layoutPositioning, setLayoutPositioning] = useState();
  const [mode, setMode] = useState();
  const [refreshSizeToggle, setRefreshSizeToggle] = useState();

  const modeDataSource = [
    { id: 'fit', name: 'fit' },
    { id: 'scale', name: 'scale' },
    { id: 'stretch', name: 'stretch' },
    { id: 'flex', name: 'flex' },
  ];
  useEffect(() => {
    const transformer = stage?.findOne('Transformer');
    if (!transformer || !mode) return;
    if (mode === 'flex') {
      transformer.enabledAnchors(transformerAnchors);
    } else {
      transformer.enabledAnchors(transformerAnchorsFull);
    }
  }, [stage, mode]);

  useEffect(() => {
    updateRefreshSizeToggle();
  }, [refreshToggle]);

  useEffect(() => {
    if (!image) return;
    setMode(image.getAttr('mode'));
  }, [group, image, background, refreshToggle]);

  const changeMode = (val) => {
    image.setAttr('mode', val);
    setMode(val);
    propertyChanged();
  };

  const propertyChanged = () => {
    props.scaleImage(image);
    refreshTransform(group);

    if (onPropertyChanged) {
      onPropertyChanged();
    }
  };

  const imageChanged = () => {
    if (onPropertyChanged) {
      onPropertyChanged();
    }
  };

  const updateRefreshSizeToggle = () => {
    setRefreshSizeToggle((refreshSizeToggle) => !refreshSizeToggle);
  };

  const rotationChanged = () => {
    updateRefreshSizeToggle();
    propertyChanged();
  };

  return (
    <div>
      <div
        className={`${globalStyles.bottomBorderDivider} ${globalStyles.bottomBigPaddings}`}
      >
        <DataProperties
          scaleImage={props.scaleImage}
          uploadFile={props.uploadFile}
          deleteImage={props.deleteImage}
          onPropertyChanged={propertyChanged}
          onImageChanged={imageChanged}
        />
      </div>

      <div
        className={`${globalStyles.bottomBorderDivider} ${globalStyles.selectBlock} ${globalStyles.gapBlock}`}
      >
        <PositionSizeControl
          element={background}
          group={group}
          layoutPositioning={layoutPositioning}
          refreshToggle={refreshSizeToggle}
          onPropertyChanged={propertyChanged}
        />
        <PositioningControl
          setLayoutPositioning={setLayoutPositioning}
        />
        <SelectControl
          label='Mode'
          dataSource={modeDataSource}
          value={mode}
          onChange={changeMode}
        />
      </div>

      {image && (
        <div className={globalStyles.bottomBorderDivider}>
          <CroppingControl
            image={image}
            background={background}
            scaleImage={props.scaleImage}
            onPropertyChanged={propertyChanged}
          />
        </div>
      )}

      <div className={globalStyles.bottomBorderDivider}>
        <BackgroundBorder
          element={background}
          onPropertyChanged={propertyChanged}
          image={image}
        />
      </div>

      <div className={globalStyles.bottomBorderDivider}>
        <RotationControl
          group={group}
          element={background}
          refreshToggle={refreshToggle}
          onPropertyChanged={rotationChanged}
        />
      </div>

      <div className={globalStyles.bottomBorderDivider}>
        <OpacityControl
          element={group}
          onPropertyChanged={propertyChanged}
        />
      </div>
    </div>
  );
}
